import { render, staticRenderFns } from "./CList.vue?vue&type=template&id=60db883f"
import script from "./CList.vue?vue&type=script&lang=js"
export * from "./CList.vue?vue&type=script&lang=js"
import style0 from "./CList.vue?vue&type=style&index=0&id=60db883f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports